import { Button, Form, Input } from "antd";

type Name = {
  firstName?: string;
  lastName?: string;
};

type Props = {
  initialValues: Name;
  onFinish: (name: Name) => void;
  onReset?: () => void;
};

export function EditNameForm({ initialValues, onFinish, onReset }: Props) {
  const [form] = Form.useForm();

  const handleFinish = (values: Name) => {
    onFinish(values);
  };

  const handleReset = () => {
    form.resetFields();
    onReset?.();
  };

  return (
    <Form
      form={form}
      initialValues={initialValues}
      onFinish={handleFinish}
      onReset={handleReset}
      layout="vertical"
    >
      <Form.Item
        name="firstName"
        rules={[{ required: true, message: "First Name is required" }]}
        className="mb-2"
        label="First Name"
      >
        <Input type="text" placeholder="Eg. Max" autoFocus />
      </Form.Item>
      <Form.Item
        name="lastName"
        rules={[{ required: true, message: "Last Name is required" }]}
        className="mb-2"
        label="Last Name"
      >
        <Input type="text" placeholder="Eg. Mustermann" />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
        <Button htmlType="reset" className="ml-2">
          Cancel
        </Button>
      </Form.Item>
    </Form>
  );
}
